import React, { useEffect, useMemo, useState } from 'react';
import { deletePortlet, getPortlets } from '../../../api/managerApi';
import PortletCreate from './PortletCreate';
import PortletDetail from './PortletDetail';
import PortletEdit from './PortletEdit';
import './portlet.css';

function PortletList() {
  const PORTLET_LIST_HEIGHT = 520;
  const [loading, setLoading] = useState(true);
  const [portlets, setPortlets] = useState([]);
  const [panel, setPanel] = useState({ mode: 'empty', portletId: null });

  const loadData = async () => {
    setLoading(true);
    try {
      const rows = await getPortlets();
      setPortlets(Array.isArray(rows) ? rows : []);
    } catch (err) {
      console.error('포틀릿 조회 실패:', err);
      alert('포틀릿 조회 실패');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const sortedPortlets = useMemo(
    () => [...portlets].sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0) || (a.portlet_pk || 0) - (b.portlet_pk || 0)),
    [portlets]
  );

  const selectedPortlet = useMemo(
    () => portlets.find((p) => String(p.portlet_pk) === String(panel.portletId)),
    [portlets, panel.portletId]
  );

  const handleDeletePortlet = async (portlet) => {
    if (!window.confirm(`포틀릿을 삭제하시겠습니까? (${portlet.portlet_label})`)) return;
    await deletePortlet(portlet.portlet_pk);
    await loadData();
    setPanel({ mode: 'empty', portletId: null });
  };

  const isActive = (value) => value === true || value === 1 || value === '1' || value === 'true';

  const renderRightPanel = () => {
    switch (panel.mode) {
      case 'empty':
        return (
          <div className="mgr-right-empty">
            <span style={{ fontSize: '1.8rem' }}>⊞</span>
            <span>포틀릿을 선택하세요.</span>
          </div>
        );
      case 'create':
        return (
          <PortletCreate
            onSuccess={async (created) => {
              await loadData();
              setPanel({ mode: 'detail', portletId: created.portlet_pk });
            }}
            onCancel={() => setPanel({ mode: 'empty', portletId: null })}
          />
        );
      case 'detail':
        return (
          <PortletDetail
            portlet={selectedPortlet}
            onEdit={(portlet) => setPanel({ mode: 'edit', portletId: portlet.portlet_pk })}
            onDelete={handleDeletePortlet}
          />
        );
      case 'edit':
        return (
          <PortletEdit
            portletId={panel.portletId}
            onSuccess={async (updated) => {
              await loadData();
              setPanel({ mode: 'detail', portletId: updated.portlet_pk });
            }}
            onCancel={() => setPanel({ mode: 'detail', portletId: panel.portletId })}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="mgr-page container-fluid p-0 mt-3">
      <div className="mgr-header">
        <h5 className="mgr-header-title">포틀릿 관리</h5>
        <button className="btn btn-primary btn-sm" onClick={() => setPanel({ mode: 'create', portletId: null })}>
          + 포틀릿 생성
        </button>
      </div>

      {loading ? (
        <div className="mgr-loading">로딩 중...</div>
      ) : (
        <div className="mgr-split">
          <div className="mgr-left">
            <div className="mgr-left-header">포틀릿 목록</div>
            {sortedPortlets.length === 0 ? (
              <div className="mgr-empty-list">등록된 포틀릿이 없습니다.</div>
            ) : (
              <ul
                className="mgr-list"
                style={{ height: `${PORTLET_LIST_HEIGHT}px`, overflowY: 'auto', flex: '0 0 auto' }}
              >
                {sortedPortlets.map((portlet) => (
                  <li key={portlet.portlet_pk} className="mgr-list-item">
                    <div
                      className={`mgr-list-item-row${String(panel.portletId) === String(portlet.portlet_pk) ? ' selected' : ''}`}
                      onClick={() => setPanel({ mode: 'detail', portletId: portlet.portlet_pk })}
                    >
                      <span className="mgr-list-item-label">{portlet.portlet_label}</span>
                      <span className={`mgr-badge ${isActive(portlet.is_active) ? 'mgr-badge-active' : 'mgr-badge-inactive'}`}>
                        {isActive(portlet.is_active) ? '활성' : '비활성'}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="mgr-right">
            {renderRightPanel()}
          </div>
        </div>
      )}
    </div>
  );
}

export default PortletList;
